import React from 'react';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Modal } from 'apps/sigma2-ui/src/components/ui/Modal';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { useUserUploadModal } from 'apps/sigma2-ui/src/users/lib/useUserUploadModal';

export const UserUploadModal = ({
  onClose,
  onComplete,
  userId,
}: {
  onClose: () => void;
  onComplete: (userUploadId: string) => void;
  userId: string;
}) => {
  const {
    modalTitle,
    modalText,
    uploadFileButtonBehavior,
    uploadFileButtonLabel,
    uploadFileButtonDisabled,
    errorMessage,
    selectedFileMessage,
    dropzone,
  } = useUserUploadModal({
    userId,
    onComplete,
  });

  return (
    <Modal
      show={true}
      onClose={onClose}
      title={modalTitle}
      scrollable={true}
      data-hello-world={'true'}
    >
      <div className={'h-[40vh]'}>
        <Spacing size={'md'} direction={'vertical'}>
          <Paragraph>{modalText}</Paragraph>
          <Spacing size={'md'} direction={'horizontal'}>
            {selectedFileMessage && (
              <Paragraph>{selectedFileMessage}</Paragraph>
            )}

            {errorMessage && <Paragraph>{errorMessage}</Paragraph>}

            <Button
              behavior={uploadFileButtonBehavior}
              text={uploadFileButtonLabel}
              disabled={uploadFileButtonDisabled}
            />
          </Spacing>

          {dropzone}
        </Spacing>
      </div>
    </Modal>
  );
};
